import { useContext, useState } from "react";
import Select from "../../components/Select";
import Search from "../../components/Search";
import { CenterContext, StaffContext } from "../../../../Context";
import SelectFromList from "../../components/SelectFromList";
import HtTabs from "../../components/HtTabs";
import Classes from "./components/Classes";
import WeekChooser from "../../components/WeekChooser";

import { useNavigate, useParams } from "react-router-dom";

export default function TimeTable2() {
  let { locations, center } = useContext(CenterContext);
  const params = useParams()
  const navigate = useNavigate()
  const week = params.week ? params.week : new Date().startOfWeek()
  const { staffAll } = useContext(StaffContext)
  const [t,setT] = useState([])
  const [search, setSearch] = useState("");
  const [teacherFilter, setTeacherFilter] = useState("");
  const [status, setStatus] = useState("Active");

  const l = localStorage.getItem("location")
  const [location, setLocation] = useState(
    l && l<2 ? locations[localStorage.getItem("location")]._id : locations[0]._id
  );



  const updateLocation = (newLocation) => {
    setLocation(locations[newLocation]._id)
  }

  const teachers = staffAll
 
  let labels = locations.map(l => l.name)
 
  let components = [...locations.map(l => <Classes location={l} teacherFilter={teacherFilter} search={search} status={status} week={week} setT={setT} key={l._id} />)]



  return (
    <div>

        <HtTabs
        labels={labels}
       
        components={components}
        localStorage="location"
        setLocation={updateLocation}
        nextToTabs={
            <div
              style={{ alignItems: "center", display: "flex", paddingTop: 3 }}
            >
              <WeekChooser value={week} setValue={(newWeek)=> navigate(`/timetable/${newWeek.tDate()}`)} /* style={{marginBottom:12}} */ />
              <div style={{ fontSize: 11, marginRight: 10, width: 100 }}>
                <div className="beginner-legend">Beginner</div>
                <div className="intermediate-legend">Intermediate</div>
                <div className="advanced-legend">Advanced</div>
              </div>
              <Select
                items={[...center.classTypes, "Free time","No foreign teacher"]}
                value={status}
                setValue={setStatus}
                size="small"
                sx={{ mr: 2, width: 200 }}
                label="Status"
              />
              <SelectFromList
                value={teacherFilter}
                setValue={setTeacherFilter}
                choices={teachers.filter(teacher=>t.includes(teacher._id)).sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))}
                label="Teachers"
                style={{ width: 200 }}
                size="small"
                filter="Teacher"
                none
              />
              
              <Search
                search={search}
                setSearch={setSearch}
                size="small"
                sx={{ ml: 2 }}
              />
             
            </div>
          }
        />

    </div>
  );
}



